import React from 'react';
import { connect } from 'react-redux';
import SimpleContractList from '../../generic-components/simpleContractList';
import R from 'ramda';
import queryString from 'query-string';
import { StyleSheet } from 'aphrodite';
import LoadingOverlay from '../../../tc-ui/loading-overlay';
import { RaisedButton } from 'material-ui';
import pluralize from 'pluralize';
import moment from 'moment';

const styles = StyleSheet.create({
  container: { height: '56px', display: 'flex', paddingLeft: '16px', borderBottom: '1px solid rgba(0, 0, 0, 0.1)', alignItems: 'center' },
  texts: { width: '70%', color: 'rgba(0, 0, 0, 0.77)', cursor: 'pointer' },
  profileImage: { width: '7%', textAlign: 'left' },
  companyName: { fontSize: '14px' },
  locationName: { fontSize: '13px' },
  commentsButton: { padding: '0', height: '24px', width: '24px', top: '4px' },
  yearNtimestamp: { display: 'flex', color: 'rgba(0, 0, 0, 0.77)', flexDirection: 'column', textAlign: 'right', width: '10%' },
  comments: { display: 'inline-block', marginLeft: '8px', width: '4%', cursor: 'pointer' },
});
const getGenitiveCase = (string) => {
  if (!string) return string;
  if (string.slice(-1) === 's') return `${string}'`;
  return `${string}'s`;
};
const PartnerList = ({ sentPartners, template, sendingContracts, companyName }) => {
  if (!template._id) return <div/>;
  const goToSendAssets = () => window.location = `${
    process.env.NEW_SYSTEM_URL
  }/partner-management/send-assets?${queryString.stringify({
    go_back_to: window.location.href,
    templateids: [template._id],
    message: `Please find ${getGenitiveCase(template.locationName === companyName ? template.locationName : `${template.locationName } - ${companyName}`)} ${moment(template.startDate).utc().format('DD MMM YYYY')} - ${moment(template.endDate).utc().format('DD MMM YYYY')} rates below. We are using TourConnect as they provide several standardised download formats that should make it easy for you to read and load our rates.\n\nIf you have any questions please let me know and thank you for your support.`,
    subject: `${getGenitiveCase(template.locationName === companyName ? template.locationName : `${template.locationName } - ${companyName}`)} ${moment(template.startDate).utc().get('year')}-${moment(template.endDate).utc().get('year')} Rates`,
  })}&jwt=${localStorage.getItem('jwt')}`;
  return (
    <div>
      <div style={{ width: '90%', margin: 'auto' }}>
        <RaisedButton
          label="Send to More Partners"
          secondary
          labelStyle={{ textTransform: 'none' }}
          style={{ float: 'right', margin: '16px 64px 0 0' }}
          onTouchTap={goToSendAssets}
        />
        <SimpleContractList
          contracts={sentPartners.map(obj => {
            // Have to do this because stupid me modified "versions" in graphql when I should just use the another field "allVersions"
            // for that purpose, so here we have to change it back
            return { ...obj, versions: R.dropLast(1, obj.versions), viewerIsSender: true };
          })}
          header={`${sentPartners.length} ${pluralize('partner', sentPartners.length)} ${pluralize('have', sentPartners.length)} received this template.`}
        />
      </div>
      <LoadingOverlay loading={sendingContracts} />
    </div>
  );
};

const mapStateToProps = ({ contracting, user }) => ({
  template: {
    _id: contracting.contractActivitiesProducts.getIn(['leftNav', 'contractId']),
    startDate: contracting.contractActivitiesProducts.getIn(['leftNav', 'startDate']),
    endDate: contracting.contractActivitiesProducts.getIn(['leftNav', 'endDate']),
    templateId: contracting.contractActivitiesProducts.getIn(['leftNav', 'contractId']),
    locationId: contracting.contractActivitiesProducts.getIn(['leftNav', 'locationId']),
    templateName: contracting.contractActivitiesProducts.getIn(['leftNav', 'templateName']),
    locationName: contracting.contractActivitiesProducts.getIn(['leftNav', 'locationName']),
    supplierInfo: {
      marketInfo: contracting.contractActivitiesProducts.getIn(['leftNav', 'supplierInfo', 'marketInfo']),
    },
  },
  companyName: user.getIn(['company', 'companyName']),
  sendingContracts: contracting.supplierWizard.get('sendingContracts'),
  sentPartners: contracting.contractActivitiesProducts.getIn(['leftNav', 'sentPartners']) ? contracting.contractActivitiesProducts.getIn(['leftNav', 'sentPartners']).toJS() : [],
});
PartnerList.contextTypes = {
  router: React.PropTypes.object.isRequired,
};
export default connect(mapStateToProps)(PartnerList);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/draftNTemplate-container/partner-list.jsx